import {createRoot} from '@wordpress/element';
import SpacesMap from './components/SpacesMap';

window.addEventListener('DOMContentLoaded', (event) => {
    const blockElements = document.getElementsByClassName(`ebo-spaces-map`);
    for (let blockElement of blockElements) {
        const attributes = JSON.parse(blockElement.dataset.gutenbergAttributes);
        createRoot(blockElement).render(<SpacesMap attributes={attributes}/>);
    }
});
